import styled from 'styled-components';
import IconRestartStyled from '../IconRestart/IconRestart.styled';

const IconNextStyled = styled(IconRestartStyled)`
  position: relative;
  top: -4px;
`;

export default IconNextStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/IconNext/IconNext.styled.js